import axios, { AxiosInstance } from "axios";

import { getBackendApiUrlForCurrentInstance } from "../config/backendUrl";

export async function getApiClient(
  getAccessToken: () => Promise<string>
): Promise<AxiosInstance> {
  const client = axios.create({
    baseURL: getBackendApiUrlForCurrentInstance(),
  });
  client.interceptors.request.use(async (config) => {
    config.headers["Authorization"] = `Bearer ${await getAccessToken()}`;
    return config;
  });
  return client;
}

export function getApiClientWithAccessToken(
  accessToken: string
): AxiosInstance {
  const client = axios.create({
    baseURL: getBackendApiUrlForCurrentInstance(),
  });
  client.interceptors.request.use((config) => {
    config.headers["Authorization"] = `Bearer ${accessToken}`;
    return config;
  });
  return client;
}
